<div data-testid="sales-request-view-page" class="p-6 max-w-5xl">
  <div class="flex items-center justify-between mb-6">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ "distribution.sales_request.view_title" | translate }}
      @if (request(); as r) {
        <span class="ml-2 text-gray-500">{{ r.series }}</span>
      }
    </h2>
    <div class="flex gap-2">
      @if (isPending() && canApprove()) {
        <p-button
          data-testid="sales-request-approve-btn"
          severity="success"
          [label]="'common.actions.approve' | translate"
          (onClick)="onApprove()"
        />
        <p-button
          data-testid="sales-request-reject-btn"
          severity="danger"
          [outlined]="true"
          [label]="'common.actions.reject' | translate"
          (onClick)="onReject()"
        />
      }
      @if (isApproved() && canCreateOrder()) {
        <p-button
          data-testid="sales-request-create-order-btn"
          [label]="'distribution.sales_request.create_order' | translate"
          (onClick)="onCreateOrder()"
        />
      }
      <p-button
        severity="secondary"
        [outlined]="true"
        [label]="'common.actions.back' | translate"
        (onClick)="onBack()"
      />
    </div>
  </div>

  @if (request(); as r) {
    <dl class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3 mb-6">
      <div>
        <dt class="text-sm text-gray-500">
          {{ "distribution.fields.series" | translate }}
        </dt>
        <dd>{{ r.series }}</dd>
      </div>
      <div>
        <dt class="text-sm text-gray-500">
          {{ "distribution.fields.status" | translate }}
        </dt>
        <dd>
          @if (r.status) {
            <p-tag
              data-testid="sales-request-status-tag"
              [value]="'distribution.status.request.' + r.status | translate"
              [severity]="statusSeverity(r.status)"
            />
          }
        </dd>
      </div>
      <div>
        <dt class="text-sm text-gray-500">
          {{ "distribution.fields.title" | translate }}
        </dt>
        <dd>{{ r.title }}</dd>
      </div>
      <div>
        <dt class="text-sm text-gray-500">
          {{ "distribution.fields.schedule_date" | translate }}
        </dt>
        <dd>{{ r.scheduleDate | date: "dd/MM/yyyy" }}</dd>
      </div>
      <div class="md:col-span-2">
        <dt class="text-sm text-gray-500">
          {{ "distribution.fields.description" | translate }}
        </dt>
        <dd>{{ r.description || "-" }}</dd>
      </div>
      <div class="md:col-span-2">
        <dt class="text-sm text-gray-500">
          {{ "distribution.fields.sales_orders" | translate }}
        </dt>
        <dd>
          @for (soId of r.salesOrderIds ?? []; track soId) {
            <a
              class="text-blue-600 underline mr-2"
              [href]="'/distribution/sales-order/view/' + soId"
              >#{{ soId }}</a
            >
          } @empty {
            <span class="text-gray-400">-</span>
          }
        </dd>
      </div>
    </dl>

    <h3 class="text-lg font-semibold mb-2">
      {{ "distribution.fields.items" | translate }}
    </h3>
    <p-table data-testid="sales-request-items-table" [value]="r.items ?? []">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "distribution.fields.sku_code" | translate }}</th>
          <th>{{ "distribution.fields.quantity" | translate }}</th>
          <th>{{ "distribution.fields.description" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.skuCode }}</td>
          <td>{{ item.quantity | number: "1.0-3" }}</td>
          <td>{{ item.description }}</td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>

<p-confirmDialog
  [acceptLabel]="'common.actions.confirm' | translate"
  [rejectLabel]="'common.actions.cancel' | translate"
/>
<p-toast />
